import React, { useState } from 'react';
import DatePicker from 'react-datepicker'
// import fr from '@fullcalendar/core/locales/fr'
import fr from 'date-fns/locale/fr';
import { useTranslation } from 'react-i18next';


function DateFilter(props) {
  const { t } = useTranslation();
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");

  return (
    <div className='d-flex'>
      <DatePicker
        selected={startDate}
        locale={fr}
        placeholderText={t('dateFilter.startDate')}
        className="form-control form-control-md"
        onChange={(date) => {
          setStartDate(date);
          props.filterElement(date, endDate)
        }}
        selectsStart
        startDate={new Date()}
        endDate={endDate}
      />

      <DatePicker
        selected={endDate}
        locale={fr}
        className="mx-1 form-control form-control-md"
        onChange={(date) => {
          setEndDate(date);
          props.filterElement(startDate, date)
        }}
        selectsEnd
        startDate={startDate}
        placeholderText={t('dateFilter.endDate')}
        endDate={new Date()}
        minDate={startDate}
      />
      <button onClick={() => props.filterElement(startDate, endDate)} className="btn colorYelloSkanPay btn-md mx-2 text-black"><i className="fa fa-search"></i></button>
    </div>
  );
}
export default DateFilter;